type Platform = "ios" | "android" | "other"

export const isABotUserAgent = (ua?: string) => {
  const userAgent = ua ?? (typeof navigator !== "undefined" ? navigator.userAgent : null)
  if (!userAgent) {
    return false
  }

  // tester- is used as a prefix for the user agent on our tests (Datadog Syntethics)
  // The list of the bots https://udger.com/resources/ua-list/crawlers
  return /tester-|bot|crawler|spider|crawling|HeadlessChrome|Googlebot|Mediapartners-Google|AdsBot-Google|googleweblight|Storebot-Google|Google-PageRenderer|Bingbot|BingPreview|Slurp|DuckDuckBot|baiduspider|yandex|sogou|LinkedInBot|bitlybot|tumblr|vkShare|quora link preview|facebookexternalhit|facebookcatalog|Twitterbot|applebot|redditbot|Slackbot|Discordbot|WhatsApp|SkypeUriPreview|ia_archiver|meta-externalagent|AhrefsBot|OAI-SearchBot|GPTBot/i.test(
    userAgent,
  )
}

/**
 * Return device's OS, based on user agent (only for mobile web)
 */
export const getMobileWebOS = (): Platform => {
  if (typeof navigator === "undefined") return "other"

  const ua = navigator.userAgent

  if (/android/i.test(ua)) {
    return "android"
  }

  if (/iPad|iPhone|iPod/.test(ua)) {
    return "ios"
  }

  return "other"
}
